var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonochromatic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 327 118",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m93.1125828 11.7961629c-14.0395665 10.6788067-23.1125828 27.6247-23.1125828 46.7038371s9.0730163 36.0250304 23.1125828 46.703837c-9.73507 7.404711-21.858092 11.796163-35 11.796163-32.0946933 0-58.1125828-26.1913421-58.1125828-58.5s26.0178895-58.5 58.1125828-58.5c13.141908 0 25.26493 4.391452 35 11.7961629zm105.0000002 0c-14.039567 10.6788067-23.112583 27.6247-23.112583 46.7038371s9.073016 36.0250304 23.112583 46.703837c-9.73507 7.404711-21.858092 11.796163-35 11.796163-32.094693 0-58.112583-26.1913421-58.112583-58.5s26.01789-58.5 58.112583-58.5c13.141908 0 25.26493 4.391452 35 11.7961629zm70 105.2038371c-32.094693 0-58.112583-26.1913421-58.112583-58.5s26.01789-58.5 58.112583-58.5 58.112583 26.1913421 58.112583 58.5-26.01789 58.5-58.112583 58.5z",
    fillRule: "evenodd",
    transform: "translate(0 .5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonochromatic);
export default __webpack_public_path__ + "static/media/monochromatic.6bf813a2da0a1f380afe4c7a23fbe9cd.svg";
export { ForwardRef as ReactComponent };